var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2.88675C28.094 1.10042 31.906 1.10042 35 2.88675L50.9808 12.1132C54.0748 13.8996 55.9808 17.2008 55.9808 20.7735V39.2265C55.9808 42.7992 54.0748 46.1004 50.9808 47.8867L35 57.1132C31.906 58.8996 28.094 58.8996 25 57.1133L9.01924 47.8868C5.92523 46.1004 4.01924 42.7992 4.01924 39.2265V20.7735C4.01924 17.2008 5.92523 13.8996 9.01924 12.1132L25 2.88675Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 6.31976C28.1893 4.62275 31.8107 4.62275 34.75 6.31976L48.1327 14.0463C51.072 15.7433 52.8827 18.8795 52.8827 22.2735V37.7265C52.8827 41.1205 51.072 44.2567 48.1327 45.9537L34.75 53.6802C31.8107 55.3773 28.1893 55.3773 25.25 53.6802L11.8673 45.9537C8.928 44.2567 7.11731 41.1205 7.11731 37.7265V22.2735C7.11731 18.8795 8.928 15.7433 11.8673 14.0463L25.25 6.31976Z",
    fill: "#4A4A4A",
    stroke: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7953 21.5695C25.8041 21.5432 25.8084 21.517 25.8172 21.4907H22.9603C22.6127 21.4917 22.2699 21.5723 21.9583 21.7263C21.6466 21.8802 21.3743 22.1034 21.1622 22.3788L18.2134 26.2551C17.9973 26.5375 17.8518 26.8675 17.7891 27.2176H24.1984L25.7953 21.5695Z",
    fill: "url(#paint0_linear_6143_38786)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2014 28.0923H17.8008C17.8726 28.4403 18.0271 28.766 18.2514 29.0417L28.1433 41.2917L28.0952 41.1298L24.2014 28.0923Z",
    fill: "url(#paint1_linear_6143_38786)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9036 41.1254C31.4737 41.9405 41.8351 28.8453 41.7475 29.0418C41.9713 28.7652 42.1271 28.44 42.2024 28.0923H35.7974L31.9036 41.1254Z",
    fill: "url(#paint2_linear_6143_38786)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8391 22.3788C38.627 22.1034 38.3547 21.8802 38.043 21.7263C37.7313 21.5723 37.3886 21.4917 37.0409 21.4907H34.1797C34.1918 21.5177 34.202 21.5455 34.2103 21.5738L35.8028 27.2176H42.2122C42.1494 26.8675 42.0039 26.5375 41.7878 26.2551L38.8391 22.3788Z",
    fill: "url(#paint3_linear_6143_38786)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1172 28.0923L28.9366 40.876L29.2472 41.9085C29.3445 42.2392 29.7138 42.2442 29.9997 42.2498C30.2854 42.2442 30.655 42.2394 30.7522 41.9085L31.0628 40.876L34.8822 28.0923H25.1172Z",
    fill: "url(#paint4_linear_6143_38786)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.887 27.2175C34.797 26.8923 33.4139 21.9825 33.3645 21.81C33.3391 21.7182 33.2842 21.6372 33.2084 21.5795C33.1325 21.5218 33.0398 21.4906 32.9445 21.4906H27.0558C26.6142 21.4732 26.5817 22.0656 26.4783 22.3656L25.1133 27.2175H34.887Z",
    fill: "url(#paint5_linear_6143_38786)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5228 38.7588C22.959 38.6464 22.4412 38.3696 22.0347 37.9631C21.6282 37.5566 21.3514 37.0388 21.239 36.475C21.2188 36.3762 21.1651 36.2874 21.087 36.2236C21.0089 36.1598 20.9111 36.125 20.8103 36.125C20.7094 36.125 20.6116 36.1598 20.5335 36.2236C20.4554 36.2874 20.4017 36.3762 20.3815 36.475C20.2692 37.0388 19.9923 37.5566 19.5858 37.9631C19.1793 38.3696 18.6615 38.6464 18.0978 38.7588C18.0002 38.7805 17.913 38.8348 17.8505 38.9127C17.788 38.9907 17.7539 39.0876 17.7539 39.1875C17.7539 39.2875 17.788 39.3844 17.8505 39.4623C17.913 39.5403 18.0002 39.5946 18.0978 39.6163C18.6615 39.7286 19.1793 40.0055 19.5858 40.412C19.9923 40.8185 20.2692 41.3363 20.3815 41.9C20.4017 41.9989 20.4554 42.0877 20.5335 42.1514C20.6116 42.2152 20.7094 42.2501 20.8103 42.2501C20.9111 42.2501 21.0089 42.2152 21.087 42.1514C21.1651 42.0877 21.2188 41.9989 21.239 41.9C21.3514 41.3363 21.6283 40.8185 22.0347 40.412C22.4412 40.0055 22.959 39.7286 23.5228 39.6163C23.6203 39.5946 23.7075 39.5403 23.77 39.4623C23.8325 39.3844 23.8665 39.2874 23.8665 39.1875C23.8665 39.0876 23.8325 38.9907 23.77 38.9128C23.7075 38.8348 23.6203 38.7805 23.5228 38.7588Z",
    fill: "url(#paint6_linear_6143_38786)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2228 20.3663C38.5705 20.4358 38.8898 20.6067 39.1404 20.8574C39.3911 21.1081 39.562 21.4274 39.6315 21.775C39.6517 21.8739 39.7054 21.9627 39.7836 22.0264C39.8617 22.0902 39.9594 22.1251 40.0603 22.1251C40.1612 22.1251 40.2589 22.0902 40.337 22.0264C40.4152 21.9627 40.4689 21.8739 40.489 21.775C40.5586 21.4274 40.7295 21.1081 40.9802 20.8574C41.2308 20.6067 41.5501 20.4358 41.8978 20.3663C41.9953 20.3446 42.0826 20.2903 42.1451 20.2124C42.2076 20.1344 42.2417 20.0375 42.2417 19.9375C42.2417 19.8376 42.2076 19.7407 42.1451 19.6627C42.0826 19.5848 41.9953 19.5305 41.8978 19.5088C41.5501 19.4393 41.2308 19.2684 40.9801 19.0177C40.7294 18.767 40.5586 18.4477 40.489 18.1C40.4689 18.0012 40.4152 17.9124 40.337 17.8486C40.2589 17.7848 40.1612 17.75 40.0603 17.75C39.9594 17.75 39.8617 17.7848 39.7836 17.8486C39.7054 17.9124 39.6517 18.0012 39.6315 18.1C39.562 18.4477 39.3912 18.767 39.1405 19.0177C38.8898 19.2684 38.5705 19.4393 38.2228 19.5088C38.1253 19.5305 38.038 19.5848 37.9755 19.6627C37.913 19.7407 37.8789 19.8376 37.8789 19.9375C37.8789 20.0375 37.913 20.1344 37.9755 20.2123C38.038 20.2903 38.1253 20.3446 38.2228 20.3663Z",
    fill: "url(#paint7_linear_6143_38786)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6143_38786",
    x1: 21.8031,
    y1: 21.4907,
    x2: 21.8031,
    y2: 27.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6143_38786",
    x1: 22.972,
    y1: 28.0923,
    x2: 22.972,
    y2: 41.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6143_38786",
    x1: 37.0465,
    y1: 28.0923,
    x2: 37.0465,
    y2: 41.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6143_38786",
    x1: 38.1959,
    y1: 21.4907,
    x2: 38.1959,
    y2: 27.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6143_38786",
    x1: 29.9997,
    y1: 28.0923,
    x2: 29.9997,
    y2: 42.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6143_38786",
    x1: 30.0002,
    y1: 21.4902,
    x2: 30.0002,
    y2: 27.2175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6143_38786",
    x1: 20.8102,
    y1: 36.125,
    x2: 20.8102,
    y2: 42.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6143_38786",
    x1: 40.0603,
    y1: 17.75,
    x2: 40.0603,
    y2: 22.1251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B711"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldplan);
export default __webpack_public_path__ + "static/media/goldplan.3f8ccc2a9ff635b746c489073ca040ee.svg";
export { ForwardRef as ReactComponent };